

































































import Vue, { PropType, VNode } from "vue";
import ApiSearch, { ApiSearchColumn } from "../models/ApiSearch";
import AllCheckUncheck from "@/components/AllCheckUncheck.vue";
import DateInput from "@/components/DateInput.vue";

type PageSlots = Vue["$scopedSlots"];

/** A propként kapott VNode-okat rajzolja ki (a szülő oldal slotjának eredményét). */
const SlotOutlet = Vue.extend({
  functional: true,
  props: { nodes: { type: Array as PropType<VNode[]>, default: () => [] } },
  render: (_h, ctx) => ctx.props.nodes,
});

/**
 * Az ApiSearchPage szűrősorának egy cellája Kendo grid módban: ugyanazt az
 * `apiSearch.filter.filters[field]` objektumot írja, amit a v-simple-table szűrősora.
 */
export default Vue.extend({
  components: { AllCheckUncheck, DateInput, SlotOutlet },

  props: {
    column: { type: Object as PropType<ApiSearchColumn>, required: true },
    apiSearch: { type: Object as PropType<ApiSearch>, required: true },
    multiSelectSelectedOptions: { type: Object as PropType<Record<string, unknown[]>>, required: true },
    items: { type: Array as PropType<object[]>, default: () => [] },
    pageSlots: { type: Object as PropType<PageSlots>, default: () => ({}) },
  },

  computed: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filters(): Record<string, any> {
      return this.apiSearch.filter?.filters ?? {};
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueFilter(): any {
      const filter = this.column.field ? this.filters[this.column.field] : undefined;
      return filter && "value" in filter ? filter : undefined;
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rangeFilter(): any {
      const filter = this.column.field ? this.filters[this.column.field] : undefined;
      return filter && "min" in filter ? filter : undefined;
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    multiSelectFilter(): any {
      const filter = this.column.multiselectField ? this.filters[this.column.multiselectField] : undefined;
      return filter && "options" in filter ? filter : undefined;
    },

    selectedCount(): number {
      return this.column.multiselectField ? this.multiSelectSelectedOptions[this.column.multiselectField]?.length ?? 0 : 0;
    },

    headerSlotNodes(): VNode[] {
      const slot = this.column.header ? this.pageSlots[this.column.header] : undefined;
      return slot ? slot({ column: this.column }) ?? [] : [];
    },
  },
});
